import React, { useEffect, useState, useCallback } from "react";
import NewsGrid from "../../components/NewsGrid/NewsGrid";
import FeaturedCarousel from "../../components/FeaturedCarousel/FeaturedCarousel";
import TrendingMarquee from "../../components/TrendingMarquee/TrendingMarquee";
import Loader from "../../components/Loader/Loader";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import AdSlot from "../../components/AdSlot/AdSlot";
import { fetchHomeNews } from "../../api/newsApi";
import "./HomePage.css";

// Home page is a fixed snapshot of the latest stories across every
// category - no infinite scroll, no "load more". Bump this to show more.
const HOME_ARTICLE_LIMIT = 30;
// How many of the latest stories to feature in the carousel up top.
const CAROUSEL_LIMIT = 8;

function HomePage() {
  const [newsList, setNewsList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadNews = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchHomeNews({ page: 1, limit: HOME_ARTICLE_LIMIT });
      setNewsList(data.items || []);
    } catch (err) {
      setError("We couldn't load the latest news. Please try again.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadNews();
  }, [loadNews]);

  return (
    <main>
      <div className="tt-home-wrap">
        <div className="tt-home-heading">
          <h1 className="tt-home-title">Today's Top Stories</h1>
          <p className="tt-home-subtitle">Speaking Today, Shaping Tomorrow</p>
        </div>

        <TrendingMarquee />

        {!loading && !error && <FeaturedCarousel items={newsList.slice(0, CAROUSEL_LIMIT)} />}

        <AdSlot slot="5555555555" variant="leaderboard" label="Advertisement" />

        {loading && <Loader label="Fetching today's headlines..." />}

        {!loading && error && <ErrorMessage message={error} onRetry={loadNews} />}

        {!loading && !error && (
          <>
            <NewsGrid newsList={newsList} adFrequency={6} />
            {newsList.length > 0 && <p className="tt-home-end-message">You're all caught up.</p>}
          </>
        )}
      </div>
    </main>
  );
}

export default HomePage;
